import MediaGallery from './MediaGallery';
export default MediaGallery;